import { useState, useEffect } from 'react';
import useClickOutside from "./useClickOutside";

export function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useClickOutside(() => setIsComponentVisible(false));

    const handleHideDropdown = (event) => {
        if (event.key === 'Escape') {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleHideDropdown, true);
        return () => {
            document.removeEventListener('keydown', handleHideDropdown, true);
        };
    });

    return { ref, isComponentVisible, setIsComponentVisible };
}
